import moment from 'moment';
import { ConveyorOrder, ConveyorOrderPackage } from '../model';

const IS_TAKING_TOO_LONG_MINS = 30;

export enum OrderStatusEnum {
  UNKNOWN = -1,
  NOTSEEN = 1,
  LABELING = 2,
  LABELED = 3,
  CANCEL_PENDING = 4,
  INERROR_PENDING = 5,
  SHIPPED = 6,
  CANCELED_DIVERTED = 7,
  INERROR_DIVERTED = 8,
}

export enum PackageStatusEnum {
  AT_CONVEYOR = 1,
  GETTING_LABEL,
  LABELED,
  SHIPPER_BLOCKED,
  IN_ERROR_PENDING,
  DIVERTED_SUCCESS,
  DIVERTED_IN_ERROR,
}

export const getTimeDiff = (endTime: number | undefined): [string, boolean, boolean] => {
  let diff = moment.duration(moment().diff(endTime));
  let diffHours = parseInt(diff.asHours().toString());
  let diffMinutes = parseInt(diff.asMinutes().toString()) - diffHours * 60;

  return [
    diffHours === 0
      ? `@ ${diffMinutes} min`
      : `@ ${diffHours} h` + (diffMinutes > 0 ? ` ${diffMinutes} min` : ''),
    diffMinutes >= IS_TAKING_TOO_LONG_MINS || diffHours > 0,
    diffMinutes >= 3 || diffHours > 0,
  ];
};

export const getConsolidatedPackages = (
  sortedPackages: ConveyorOrderPackage[],
  pkgStatusSuccessId: number,
): ConveyorOrderPackage[] => {
  var temp = sortedPackages.filter((x) => x.packageStatusId !== pkgStatusSuccessId);

  temp.unshift({
    packageId: -1,
    packageNumber: -1,
    packageStatusId: pkgStatusSuccessId,
    items: [
      `${sortedPackages.filter((x) => x.packageStatusId === pkgStatusSuccessId).length} Shipped`,
    ],
  });
  return temp;
};

export const getPackageStatusSx = (statusId: number) => {
  switch (statusId) {
    case 1: //Not seen
      return { color: '#ff4500', borderRadius: 0.5 };
    case 2: //Labelling
      return { bgcolor: '#ffa500', color: 'white', borderRadius: 0.5 };
    case 3: //Labelled
      return { bgcolor: '#20b2aa', color: 'white', borderRadius: 0.5 };
    case 4: //Shipper Blocked
      return { bgcolor: '#808080', color: 'white', borderRadius: 0.5 };
    case 5: //Error Pending
      return { bgcolor: '#ff00ff', color: 'white', borderRadius: 0.5 };
    case 6: //Diverted Success
      return { bgcolor: '#008000', color: 'white', borderRadius: 0.5 };
    case 7: //Error Diverted
      return { bgcolor: '#ff0000', color: 'white', borderRadius: 0.5 };
    default:
      break;
  }
};

export const canShipOrder = (order: ConveyorOrder): boolean => {
  return (
    order.orderStatusId !== OrderStatusEnum.SHIPPED &&
    order.orderStatusId !== OrderStatusEnum.CANCEL_PENDING &&
    order.orderStatusId !== OrderStatusEnum.CANCELED_DIVERTED &&
    order.packages.every(
      (p) =>
        p.packageStatusId === PackageStatusEnum.DIVERTED_SUCCESS ||
        p.packageStatusId === PackageStatusEnum.LABELED,
    )
  );
};

export const canForgetOrder = (order: ConveyorOrder): boolean => {
  return (
    order.orderStatusId === OrderStatusEnum.CANCEL_PENDING ||
    order.orderStatusId === OrderStatusEnum.INERROR_PENDING ||
    order.orderStatusId === OrderStatusEnum.CANCELED_DIVERTED ||
    order.orderStatusId === OrderStatusEnum.INERROR_DIVERTED
  );
};
